import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import { Navigate } from 'react-router-dom';
import moment from "moment";
import {
  TextInput,
} from "components/Input/Index.js";
import DateInput from "components/Input/DateInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { memberships } from "variables/markets";
import { membershipStatusData } from "variables/lists/markets";
import { postMarketMembership, getSite, getFiles } from "services/ConfigServices";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import { MarketsContext } from "context/MarketsContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import Chip from "@mui/material/Chip";
import LocalizationAutocomplete from "components/LocalizationAutocomplete/LocalizationAutocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "61.5ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "61.5ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function CreateMarketMembershipDialog(props) {
  const { closeModal, refetch } = props;
  const appContext = useContext(MarketsContext);
  const { market } = appContext;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;
  const [marketmembershipnumber, setMarketmembershipnumber] = useState("");
  const [name, setName] = useState("");
  const [internalmembershipnumber, setInternalmembershipnumber] = useState("");
  const [contactname, setContactname] = useState("");
  const [contactjob, setContactjob] = useState("");
  const [company, setCompany] = useState("");
  const [siret, setSiret] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [billingaddress, setBillingaddress] = useState(null);
  const [localizationValue, setLocalizationValue] = useState("");
  const [options, setOptions] = useState([]);
  const [validatedAddress, setValidatedAddress] = useState({});
  const loaded = useRef(false);

  const [comments, setComments] = useState("");
  const [associatedfiles, setAssociatedfiles] = useState("");
  const [description, setDescription] = useState("");

  const [groups, setGroups] = useState("");
  const [groupsParent, setGroupsParent] = useState(
    market?.parameters?.general?.groups?.[0]
  );

  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    if (
      marketmembershipnumber.length > 0 &&
      name.length > 0 &&
      groups.length > 0
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [name, groups, marketmembershipnumber]);


  const handleSubmit = async (event) => {
    createMarketMembership(event);
  };

  const handleMarketmembershipnumberChange = (event) => { setMarketmembershipnumber(event.target.value); };
  const handleNameChange = (event) => { setName(event.target.value); };
  const handleInternalmembershipnumberChange = (event) => { setInternalmembershipnumber(event.target.value); };
  const handleContactnameChange = (event) => { setContactname(event.target.value); };
  const handleContactjobChange = (event) => { setContactjob(event.target.value); };
  const handleCompanyChange = (event) => { setCompany(event.target.value); };
  const handleSiretChange = (event) => { setSiret(event.target.value); };
  const handlePhoneChange = (event) => { setPhone(event.target.value); };
  const handleEmailChange = (event) => { setEmail(event.target.value); };
  const handleBillingaddressChange = (event) => { setBillingaddress(event.target.value); };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  useEffect(() => {
    axios
      .get(getFiles(market?.parameters?.general?.groups?.[0]), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  const selectedDocuments = () => {
    let gedCardId = [];
    let getGedNames;
    if (associatedfiles !== undefined) {
      for (let i = 0; i < associatedfiles.length; i++) {
        gedCardId.push(associatedfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };
  const handleAssociatedfilesChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setAssociatedfiles(newArray);
  };

  const handleGroupChange = (nodeIds) => {
    if (nodeIds && nodeIds !== "0") {
      setGroups(nodeIds);
      axios
        .get(
          getSite(nodeIds, "parameters.parameters"),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          if (res.data.detail.parameters?.parameters?.membernumber) {
            setInternalmembershipnumber(res.data.detail.parameters.parameters.membernumber);
          }
          if (res.data.detail.name) {
            setName(res.data.detail.name);
          }
        })
        .catch(() => { });
    }
  };

  const createMarketMembership = async (event) => {
    await axios
      .post(
        postMarketMembership(market.id),
        {

          groups: [groups],
          marketmembershipnumber,
          name,
          internalmembershipnumber,
          status: "requestsent",
          daterequest: moment().format("YYYY-MM-DD"),
          contactname,
          contactjob,
          company,
          siret,
          phone,
          email,
          billingaddress,
          comments,
          associatedfiles,
          description,

        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Adhésion créée");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div>
              <TextInput
                isRequired
                inputTitle={memberships.marketmembershipnumber}
                textInput={marketmembershipnumber}
                handleTextInputChange={handleMarketmembershipnumberChange}
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={memberships.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={memberships.internalmembershipnumber}
                textInput={internalmembershipnumber}
                handleTextInputChange={handleInternalmembershipnumberChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={memberships.contactname}
                textInput={contactname}
                handleTextInputChange={handleContactnameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={memberships.contactjob}
                textInput={contactjob}
                handleTextInputChange={handleContactjobChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={memberships.company}
                textInput={company}
                handleTextInputChange={handleCompanyChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={memberships.siret}
                textInput={siret}
                handleTextInputChange={handleSiretChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={memberships.phone}
                textInput={phone}
                handleTextInputChange={handlePhoneChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={memberships.email}
                textInput={email}
                handleTextInputChange={handleEmailChange}
              />
            </div>
            <div>
              <LocalizationAutocomplete
                displayLatLng={false}
                inputTitle={memberships.billingaddress}
                value={billingaddress}
                setValue={setBillingaddress}
                inputValue={localizationValue}
                setInputValue={setLocalizationValue}
                options={options}
                setOptions={setOptions}
                setValidatedAddress={setValidatedAddress}
                validatedAddress={validatedAddress}
                loaded={loaded}
                specialWidth={"97%"}
              />
            </div>
            <div>
              <TextInput
                inputTitle={memberships.comments}
                textInput={comments}
                handleTextInputChange={handleCommentsChange}
              />
            </div>
            <div>
              <AutocompleteInput
                inputTitle={memberships.associatedfiles}
                selected={selectedDocuments()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleAssociatedfilesChange(newValue)
                }
                renderTags={(tagValue, getTagProps) =>
                  tagValue.map((option, index) => (
                    <Chip label={option.title} {...getTagProps({ index })} />
                  ))
                }
              />
            </div>
            <div>
              <TextInput
                inputTitle={memberships.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            {/* <div>
              <CustomSelect
                inputTitle={memberships.status}
                selectValue={status}
                handleSelectValueChange={handleStatusChange}
                data={membershipStatusData}
              />
            </div>
            <div>
              <DateInput
                inputTitle={memberships.dateupdate}
                dateInput={dateupdate}
                handleDateInputChange={handleDateupdateChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={memberships.daterequest}
                dateInput={daterequest}
                handleDateInputChange={handleDaterequestChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={memberships.datemembership}
                dateInput={datemembership}
                handleDateInputChange={handleDatemembershipChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={memberships.dateend}
                dateInput={dateend}
                handleDateInputChange={handleDateendChange}
              />
            </div> */}
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Créer
            </Button>
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div className={classes.treeVisible}>
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={handleGroupChange}
                  userSelectedIds={groups}
                  filterfromnode={groupsParent}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default CreateMarketMembershipDialog;
